import React from 'react';
import './index.scss';

const SaveRESTBlockWarningDialog = ({ onContinue, onCancel }) => (
    <div id="save-rest-block-warning-dialog-container">
        <div id="save-rest-block-warning-dialog-wrapper">
            <div className="save-rest-block-warning-dialog-header">
                <h4>Save Block Warning</h4>
            </div>
            <div className="save-rest-block-warning-dialog-body">
                <p>
                    The REST API block contains authentication details. For security reasons,
                    directly entered username/password values and Authorization headers will be removed from the saved block.
                </p>
            </div>
            <div className="save-rest-block-warning-dialog-footer">
                <button type="button" className="btn-Cancel" onClick={onCancel}>Cancel</button>
                <button type="button" className="btn-Continue" onClick={onContinue}>Continue</button>
            </div>
        </div>
    </div>
);

export default SaveRESTBlockWarningDialog;
